import React, { useEffect } from "react";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import FormSelectionField from "../../../components/formFields/FormSelectionField";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import ButtonWithLoading from "../../../components/common/ButtonWithLoading";
import { Typography } from "@progress/kendo-react-common";
import { requiredValidator } from "../../../components/formFields/CommonValidator";
import ShadowCard from "../../../components/common/ShadowCard";
import { getKarigarListByProcess } from "../../karigar/services/karigar.services";
import {
  clearKarigarWiseBandhaiAmountPhineSummaryReportDetails,
  clearKarigarWiseBandhaiAmountPhineSummaryReportList,
  setKarigarWiseBandhaiAmountPhineSummaryReportDetails,
} from "../reportSlice";

import { IKarigarListByProcess } from "../../karigar/karigarModel";
import FormDatePicker from "../../../components/formFields/FormDateField";
import moment from "moment";
import { getKarigarWiseBandhaiAmountPhineSummaryReport } from "../services/reports.services";
import { PROCESS_ID } from "../../../_contstants/common";

const BandhaiKarigarLedgerReportForm: React.FC = () => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.reports.loading);

  const KarigarWiseBandhaiAmountPhineSummaryReportDetails = useAppSelector(
    (state) => state.reports.KarigarWiseBandhaiAmountPhineSummaryReportDetails
  );
  const KarigarListByProcess = useAppSelector(
    (state) => state.karigar?.KarigarListByProcess
  );

  useEffect(() => {
    dispatch(getKarigarListByProcess(PROCESS_ID.bandhai));
    return () => {
      dispatch(clearKarigarWiseBandhaiAmountPhineSummaryReportDetails());
      dispatch(clearKarigarWiseBandhaiAmountPhineSummaryReportList());
    };
  }, []);

  const handleSubmit = async (values: any) => {
    try {
      const payload = {
        from_date: values.from_date
          ? moment(values.from_date).format("YYYY-MM-DD")
          : "",
        to_date: values.to_date
          ? moment(values.to_date).format("YYYY-MM-DD")
          : "",
        karigar_id: values.karigar_id ? +values.karigar_id : null,
      };
      const res = await dispatch(
        getKarigarWiseBandhaiAmountPhineSummaryReport(payload)
      );

      if (res.meta.requestStatus === "fulfilled") {
        window.open(
          `/bandhai-karigar-ledger-report/${payload.from_date}/${
            payload.to_date
          }/${payload.karigar_id || "0"}`,
          "_blank"
        );

        dispatch(
          setKarigarWiseBandhaiAmountPhineSummaryReportDetails({
            from_date: values?.from_date,
            to_date: values?.to_date,
            karigar_id: values?.karigar_id,
          })
        );
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  return (
    <GridLayout cols={[{ width: "100%" }]}>
      <GridLayoutItem>
        <ShadowCard>
          <Form
            initialValues={KarigarWiseBandhaiAmountPhineSummaryReportDetails}
            onSubmit={handleSubmit}
            render={(formRenderProps: FormRenderProps) => (
              <FormElement style={{ width: "100%" }}>
                <GridLayout
                  style={{ marginRight: 20 }}
                  gap={{ rows: 0, cols: 10 }}
                  cols={[
                    { width: "33.33%" },
                    { width: "33.33%" },
                    { width: "33.33%" },
                  ]}
                >
                  <GridLayoutItem colSpan={3}>
                    <Typography.h4
                      style={{ marginBottom: 0, marginLeft: "3px" }}
                    >
                      Bandhai Karigar Ledger Report
                    </Typography.h4>
                  </GridLayoutItem>
                  <GridLayoutItem style={{ display: "flex", gap: 10 }}>
                    <Field
                      wrapperStyle={{ width: "100%" }}
                      name="from_date"
                      label="Start Date"
                      format="dd/MM/yyyy"
                      component={FormDatePicker}
                      validator={requiredValidator}
                      astrike={true}
                    />
                    <Field
                      wrapperStyle={{ width: "100%" }}
                      name="to_date"
                      label="End Date"
                      format="dd/MM/yyyy"
                      minDate={
                        moment(
                          formRenderProps.valueGetter("from_date")
                        ).toDate() || new Date(1900, 0, 1)
                      }
                      component={FormDatePicker}
                      validator={requiredValidator}
                      astrike={true}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="karigar_id"
                      label="Karigar"
                      placeholder="Select Karigar"
                      component={FormSelectionField}
                      options={KarigarListByProcess?.map(
                        (karigar: IKarigarListByProcess) => {
                          return {
                            value: karigar?.karigar_id,
                            label: `${karigar?.karigar_name}`,
                          };
                        }
                      )}
                      validator={requiredValidator}
                      astrike={true}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem
                    style={{
                      position: "relative",
                    }}
                  >
                    <ButtonWithLoading
                      label="GET DETAILS"
                      type="submit"
                      style={{ position: "absolute", top: 42 }}
                      disabled={!formRenderProps.allowSubmit || loading}
                      loading={loading}
                    />
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            )}
          />
        </ShadowCard>
      </GridLayoutItem>
    </GridLayout>
  );
};

export default BandhaiKarigarLedgerReportForm;
